/*========LOGIN========= */
export const AUTH_LOGIN                      = 'AUTH_LOGIN';
export const AUTH_LOGIN_SUCCESS              = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAIL                 = 'AUTH_LOGIN_FAIL';

/*========GET SECURE CODE======*/
export const AUTH_GET_SECURE_SUCCESS         = 'AUTH_GET_SECURE_SUCCESS';
export const AUTH_GET_SECURE_FAIL            = 'AUTH_GET_SECURE_FAIL';

/*=========CHECK SECURE CODE=========*/
export const AUTH_CHECK_SECURE_SUCCESS       = 'AUTH_CHECK_SECURE_SUCCESS';
export const AUTH_CHECK_SECURE_FAIL          = 'AUTH_CHECK_SECURE_FAIL';

/*========RESET SECURE PASSWORD========*/
export const RESET_SECURE_PASSWORD_SUCCESS   = 'RESET_SECURE_PASSWORD_SUCCESS';
export const RESET_SECURE_PASSWORD_FAIL      = 'RESET_SECURE_PASSWORD_FAIL';

/*========LOGOUT========*/
export const LOGOUT_SUCCESS   = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL      = 'LOGOUT_FAIL';